import {
  NewsAddInput,
  NewsServiceName,
  NewsSourceOverrides,
  SelectedNewsSource
} from "@bluframe/mightychroma-mightytool-frontend-types"

import HeaderPods from "./HeaderPods"

export interface Props {
  areNewsLoading: boolean
  avNirvana: SelectedNewsSource
  bluRay: SelectedNewsSource
  hidefDigest: SelectedNewsSource
  news: NewsAddInput
  isCompact: boolean
  isSingleSource: boolean
  left: React.ReactNode

  onClear: (serviceName: NewsServiceName) => () => void
  onSetOverrides: (
    serviceName: NewsServiceName
  ) => (overrides: NewsSourceOverrides) => void
  whySoBlu: SelectedNewsSource
}

export interface ComponentProps extends Props {}

export default HeaderPods
